import { render, staticRenderFns } from "./SubscriberDetails.vue?vue&type=template&id=fa4712fc&scoped=true&"
import script from "./SubscriberDetails.vue?vue&type=script&lang=js&"
export * from "./SubscriberDetails.vue?vue&type=script&lang=js&"
import style0 from "./SubscriberDetails.vue?vue&type=style&index=0&id=fa4712fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4712fc",
  null
  
)

export default component.exports